import { render } from "./ReturnReasonListComponent.vue?vue&type=template&id=51128181"
import script from "./ReturnReasonListComponent.vue?vue&type=script&lang=js"
export * from "./ReturnReasonListComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/ReturnReason/ReturnReasonListComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "51128181"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('51128181', __exports__)) {
    api.reload('51128181', __exports__)
  }
  
  module.hot.accept("./ReturnReasonListComponent.vue?vue&type=template&id=51128181", () => {
    api.rerender('51128181', render)
  })

}


export default __exports__